export default "__VITE_ASSET__C5g7XOCF__"